import { withStyles } from '../../tools/withStyles';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Link';

const Link = withStyles(() => {})(withSounds()(Component));

export { Link };

// Commit trace: 2026-01-26T08:34:58 - docs: clarify parameter types in index.js
